module.exports = __webpack_public_path__ + "fonts/Raleway-Medium.257a2127.woff2";